/**
 * Login Button Component
 * Handles authentication state and login/logout actions
 */

import { signIn, signOut, useSession } from 'next-auth/react';
import { Button, Group, Avatar, Text, Menu } from '@mantine/core';
import { IconLogin, IconLogout, IconUser, IconCoins } from '@tabler/icons-react';

export function LoginButton() {
  const { data: session, status } = useSession();

  if (status === 'loading') {
    return (
      <Button loading variant="light">
        Loading...
      </Button>
    );
  }

  if (session?.user) {
    return (
      <Group gap="sm">
        <Group gap="xs">
          <IconCoins size={16} />
          <Text size="sm" fw={500}>
            {session.user.credits} credits
          </Text>
        </Group>

        <Menu shadow="md" width={200}>
          <Menu.Target>
            <Button
              variant="light"
              leftSection={
                <Avatar
                  src={session.user.image}
                  size="sm"
                  radius="xl"
                />
              }
            >
              {session.user.name}
            </Button>
          </Menu.Target>

          <Menu.Dropdown>
            <Menu.Label>Account</Menu.Label>
            <Menu.Item leftSection={<IconUser size={14} />}>
              Profile
            </Menu.Item>
            <Menu.Item leftSection={<IconCoins size={14} />}>
              Credits: {session.user.credits}
            </Menu.Item>
            
            <Menu.Divider />
            
            <Menu.Item
              leftSection={<IconLogout size={14} />}
              color="red"
              onClick={() => signOut()}
            >
              Sign out
            </Menu.Item>
          </Menu.Dropdown>
        </Menu>
      </Group>
    );
  }

  return (
    <Group gap="sm">
      <Button
        leftSection={<IconLogin size={16} />}
        onClick={() => signIn('google')}
        variant="light"
      >
        Sign in with Google
      </Button>
      
      <Button
        leftSection={<IconLogin size={16} />}
        onClick={() => signIn('github')}
        variant="outline"
      >
        Sign in with GitHub
      </Button>
    </Group>
  );
}